module.exports = __webpack_public_path__ + "static/media/work3.a106f416.jpg";